import {EventCreationMode} from 'src/modules/event-create/constants';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';
import {EventType} from 'src/openapi/models/EventType';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

const ATTACHMENT_NOT_UPLOADED = 'At least one active trigger attachment is required.';

export const eventTriggerAttachmentValidation = (
    mode: EventCreationMode,
    eventChangeRequest: EventChangeRequest,
    triggerAttachments: TriggerAttachment[],
): string[] => {
    const errorMassages = [];

    const activeTriggerAttachments = triggerAttachments.filter(attachment => attachment.active);

    const isInvalid = mode === EventCreationMode.update
        && eventChangeRequest.type === EventType.USER_EVENT
        && !eventChangeRequest.deprecated
        && activeTriggerAttachments.length === 0;

    if (isInvalid) {
        errorMassages.push(ATTACHMENT_NOT_UPLOADED);
    }

    return errorMassages;
};
